var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLocationPin = function SvgIconLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 6a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M9.5 9.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2c-2 0-3.912.852-5.315 2.356C5.282 5.858 4.5 7.889 4.5 10c0 2.64 1.017 5.037 2.264 6.987 1.248 1.952 2.746 3.487 3.757 4.413a2.17 2.17 0 0 0 2.958 0c1.01-.926 2.509-2.461 3.757-4.413C18.483 15.037 19.5 12.639 19.5 10c0-2.111-.782-4.142-2.185-5.644C15.912 2.852 14.001 2 12 2M7.416 5.038C8.638 3.728 10.288 3 12 3s3.362.728 4.584 2.038C17.807 6.348 18.5 8.133 18.5 10c0 2.383-.92 4.593-2.107 6.448-1.185 1.854-2.616 3.323-3.59 4.214a1.17 1.17 0 0 1-1.607 0c-.973-.891-2.404-2.36-3.59-4.214S5.5 12.383 5.5 10c0-1.867.693-3.652 1.916-4.962",
    clipRule: "evenodd"
  })));
};
export default SvgIconLocationPin;